// extracted by mini-css-extract-plugin
export default {"admin":"Admin-module__admin__MWLiO","action":"Admin-module__action__-1g1d","icon":"Admin-module__icon__-uM9u"};